import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { RequestSchedulingResponse } from "@/types";

async function confirmSchedule(
  request: string | { id: string; expected_revision: number }
): Promise<RequestSchedulingResponse> {
  const id = typeof request === "string" ? request : request.id;
  const response = await httpRequest.post<RequestSchedulingResponse>(
    `/schedulings/confirmed/${id}`, typeof request === "string" ? undefined : { expected_revision: request.expected_revision }
  );
  return response.data;
}

export function useConfirmSchedulingMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: confirmSchedule,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedulings"] });
    },
  });
}
